<template>
  <div class="mobile-remote">
    <div class="main-title">使用帮助/手机遥控功能/手机遥控功能</div>
    <h1 class="page-title">手机遥控功能</h1>
    <h4 class="content-text">
      1、在活动信息页右下角有个手机遥控器按钮，点开，手机扫描二维码可以控制大屏的点歌互动还有查看点数风暴每局的明细。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-mobileRemote1_176829223204620f0cc.webp"
      alt="松鼠酒吧大屏互动手机遥控器功能"
      class="example-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-mobileRemote2_1768292232047e652fb.webp"
      alt="松鼠酒吧大屏互动手机遥控游戏进行"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-mobileRemote3_1768292232047e6d603.webp"
      alt="松鼠酒吧大屏互动手机遥控点歌功能"
      class="mobile-image"
    />
  </div>
</template>

<script>
export default {
  name: 'MobileRemote',
};
</script>

<style lang="less" scoped>
.mobile-remote {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}
</style>
